/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Ob_Proof_AppstoreInputs */

const en_funnel_ob_proof_appstore = /** @type {(inputs: Funnel_Ob_Proof_AppstoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`App Store`)
};

const es_funnel_ob_proof_appstore = /** @type {(inputs: Funnel_Ob_Proof_AppstoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`App Store`)
};

/**
* | output |
* | --- |
* | "App Store" |
*
* @param {Funnel_Ob_Proof_AppstoreInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_ob_proof_appstore = /** @type {((inputs?: Funnel_Ob_Proof_AppstoreInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Ob_Proof_AppstoreInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_ob_proof_appstore(inputs)
	return en_funnel_ob_proof_appstore(inputs)
});